export default "__VITE_ASSET__CItrtWkR__"